import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { backendBookartUrl } from "../library/constants";
import { adminValidation } from "../library/service";
import EditProduct from "./EditProduct";
import Popup from '../components/Popup';

const ProductRetrieve = () => {
  const [isbn, setIsbn] = useState("");
  // const [data, setData] = useState({});
  const [responseData, setResponseData] = useState({});
  const [gotData, setGotData] = useState(false);
  const [searchError, setSearchError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupMessage, setPopupMessage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    authUser();
    adminAuth();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
  
    if (!token) {
      navigate("/");
      return; 
    }
  };


  const adminAuth = async () => {
    const authorized = await adminValidation();
    if (!authorized) {
      // Redirect to login page if the token has expired
      navigate('/');
    } else if (!authorized.data.is_admin) {
      navigate("/unAuthorized");
    }
  };

  const returnToStart = () => {
    setGotData(false);
    setIsbn("");
    setResponseData({});
  };

  const searchProduct = (event) => {
    event.preventDefault();
    setGotData(false);
    setSearchError(false);

    if (isbn.replace(/\s+/g, "") === "") {
      setSearchError(true);
      return;
    }

    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({ isbn: isbn.replace(/\s+/g, "") });
    const config = {
      method: "post",
      url: `${backendBookartUrl}/product_retrieve?=`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        if (response.status !== 200) {
          setSearchError(true);
          handleShowPopup('Search Product', response.data.message);
        }
        else {
          // navigate("/productEdit", { state: { data: response.data } });
          // handleShowPopup('Search Product', response.data.message);
          setGotData(true);
          setResponseData(response.data);
        }
      })
      .catch((error) => {
        setSearchError(true);
        handleShowPopup('Search Product', error.response.data.message);
        console.log(error);
      });
  };
  const handleShowPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {/* <MainHeader /> */}
      <div className="container min-height60">
        {/* <div className="back-home">
          <Link to="/admin">
            <button className="es-link colored font-16" type="submit">
              <svg viewBox="0 0 54 128" height="16" width="11">
                <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
              </svg>
              &nbsp;Back To Home
            </button>
          </Link>
          
        </div> */}
        {/* <h1 className="margin-top-10p">Edit Product</h1> */}

        <form onSubmit={searchProduct}>
          <div className="es-input-text search-term">
            <input
              id="searchKeyword"
              type="text"
              name="searchKeyword"
              placeholder="&nbsp;"
              value={isbn}
              onChange={(e) => setIsbn(e.target.value)}
            />
            <label htmlFor="searchKeyword" className="search-label">
              <h3 className="order-history-search">Search with ISBN</h3>
            </label>
            <button className="search-button search-button-order-history" type="submit">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 128"
                height="24"
                width="19"
              >
                <path
                  fill="#007398"
                  d="M19.22 76.91c-5.84-5.84-9.05-13.6-9.05-21.85s3.21-16.01 9.05-21.85c5.84-5.83 13.59-9.05 21.85-9.05 8.25 0 16.01 3.22 21.84 9.05 5.84 5.84 9.05 13.6                   9.05 21.85s-3.21 16.01-9.05 21.85c-5.83 5.83-13.59 9.05-21.84 9.05-8.26 0-16.01-3.22-21.85-9.05zm80.33 29.6L73.23 80.19c5.61-7.15 8.68-15.9 8.68-25.13 0-10.91-4.25-21.17-11.96-28.88-7.72-7.71-17.97-11.96-28.88-11.96S19.9 18.47 12.19 26.18C4.47 33.89.22 44.15.22 55.06s4.25 21.17 11.97 28.88C19.9 91.65 30.16 95.9 41.07 95.9c9.23 0 17.98-3.07 25.13-8.68l26.32 26.32 7.03-7.03"
                />
              </svg>
            </button>
          </div>
        </form>
        {searchError ? (
          <Popup
            title={popupTitle}
            message={popupMessage}
            show={showPopup}
            handleClose={handleClosePopup}
          />
        ) : (<div>
          {gotData ? (
            <div className="margin-top-10p">
              <div><h3>Product Details</h3></div>
              <EditProduct data={responseData} backToStart={returnToStart} />
            </div>
          ) : (
            <div></div>
          )}
        </div>
        )}

      </div>
      {/* <Footer /> */}
    </>
  );
};

export default ProductRetrieve;